export enum END_OF_TENANCY_MODALS_ENUM {
  CLEANING_SUPPLIES = "CLEANING_SUPPLIES",
  WHAT_IS_INCLUDED = "WHAT_IS_INCLUDED",
  WARRANTY = "WARRANTY",
}
